<template>
  <b-modal v-model="isShow" centered title="Xác nhận hỗ trợ" no-close-on-backdrop>
    <h6>Nhập ghi chú hỗ trợ:</h6>
    <b-form-input v-model="note" placeholder="Nhập ghi chú hỗ trợ" />

    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <b-button variant="primary" :disabled="isLoading" @click="submit"> Xác nhận </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
  import { updateTaskSaleSupportCustomer } from '@/services/customer-support/task'
  import { showMess } from '@/config/utils'

  export default {
    name: 'ShowImage',
    components: {
      // UpdateAFS,
    },
    data() {
      return {
        isShow: false,
        isLoading: false,
        note: '',
        id: '',
      }
    },

    methods: {
      show(id) {
        this.isShow = true
        this.id = id
        this.note = ''
      },

      close() {
        this.isShow = false
      },

      async submit() {
        try {
          this.isLoading = true
          const res = await updateTaskSaleSupportCustomer({
            id: this.id,
            note: this.note,
          })
          if (res.code === 1000) {
            this.$emit('change')
            this.isShow = false
          } else {
            showMess(this, 'Thông báo', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(
            this,
            'Thông báo',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
